// RelatedEvidence.jsx
import React from 'react';

const RelatedEvidence = ({ selectedNode }) => {
  // Dynamically generate evidence based on selected node
  const evidence = [
    selectedNode ? `"${selectedNode.name} in Cancer" - Recent Studies` : "No node selected",
    selectedNode?.type === 'drug' ? `"Clinical Outcomes with ${selectedNode.name}" - NEJM 2022` : null,
    selectedNode?.type === 'mutation' ? `"Targeting ${selectedNode.name}" - JCO 2022` : null
  ].filter(Boolean);

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Related Evidence:</h3>
      <ul className="space-y-2">
        {evidence.map((item, index) => (
          <li key={index} className="flex items-start">
            <span className="mr-2">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedEvidence;